import Tag from '@decisiv/ui-components/lib/components/Tag';

import HighlightText from 'components/HighlightedText';
import { useSearchContext } from 'contexts/SearchContext';
import { Container } from 'pages/Teams/Cells/PlatformAccountsCell/styles';

type Props = {
  rowData: Pick<SentinelTeam, 'scheduledForDeletionAt'> & {
    platformAccounts: Pick<
      SentinelTeam['platformAccounts'][0],
      'id' | 'sourceId'
    >[];
  };
};

export default function AccountIdCell({
  rowData: { platformAccounts, scheduledForDeletionAt },
}: Props) {
  const { searchString } = useSearchContext();

  const scheduledForDeletionProps = {
    ...(scheduledForDeletionAt && {
      palette: 'pastel' as const,
      color: 'licoriceMousse' as const,
      variant: undefined,
    }),
  };

  return (
    <Container>
      {platformAccounts.map((platformAccount) => (
        <Tag
          key={platformAccount.id}
          size="small"
          variant="outline"
          text={
            <HighlightText
              text={platformAccount.sourceId}
              searchText={searchString}
            />
          }
          {...scheduledForDeletionProps}
        />
      ))}
    </Container>
  );
}
